<template>
    <table-ish>
        <table-ish-row
            v-for="file in files"
            :key="file.uuid"
        >
            <table-ish-cell class="border-grey-lighter!">
                <truncate-hack>
                    {{ file.name }}
                </truncate-hack>
            </table-ish-cell>

            <table-ish-cell
                :shrink="true"
                class="text-right border-grey-lighter!"
            >
                <laroute-link
                    :to="{
                        name: 'storage.files.show',
                        params: {
                            file: file.uuid,
                            download: true
                        }
                    }"
                    class="block w-6 h-6"
                >
                    <base-svg
                        name="icon-cloud-download"
                        class="w-full h-full"
                    />
                </laroute-link>
            </table-ish-cell>
        </table-ish-row>
    </table-ish>
</template>

<script>
    export default {
        props: {
            files: {
                type: Array,
                required: true
            }
        }
    }
</script>
